import React, {useState} from 'react';
import cx from 'classnames';
import {subscribe} from 'klaviyo-subscribe';
import {ReactComponent as Arrow} from 'src/images/svg/Arrow.svg';

import * as styles from './signup.module.css';

export const Signup = ({
	className,
	listId = 'LK8Sxc',
	customFields = {},
	centerResponse = false,
	successComponent = false,
}) => {
	const [email, setEmail] = useState('');
	const [success, setSuccess] = useState(false);
	const handleSubmit = e => {
		e.preventDefault();
		const form = e.currentTarget;
		subscribe(listId, email, customFields).then(() => {
			form.reset();
			setSuccess(true);
		});
	};

	const successMessage = successComponent ? (
		<div>{successComponent}</div>
	) : (
		<p
			className={cx(
				'label-italic',
				styles.message,
				centerResponse && styles.center,
			)}
		>
			Thank you! Please check your email to confirm your subscription.
		</p>
	);

	return (
		<div className={cx(styles.signup, className)}>
			{!success ? (
				<form onSubmit={e => handleSubmit(e)} className={styles.form}>
					<input
						name="email"
						className={cx('label-italic', styles.emailInput)}
						placeholder="Enter your email"
						type="email"
						required
						aria-label="Enter your email"
						onChange={e => {
							setEmail(e.currentTarget.value);
						}}
					/>
					<button
						type="submit"
						className={cx('reset', styles.submitButton)}
						aria-label="Submit"
					>
						<Arrow />
					</button>
				</form>
			) : (
				successMessage
			)}
		</div>
	);
};
